// Centralized restaurant info — single source of truth
export const RESTAURANT = {
  name: "Globo Dancing",
  legalName: "GLOBO DANCING SARL",
  tagline: "Restaurant portugais dansant · Trappes",
  shortTagline: "Restaurant dansant",
  description: "Restaurant portugais familial à Trappes (78). Plats du jour savoureux, cuisine traditionnelle portugaise (bacalhau, polvo, pastéis de nata) et soirées dansantes le week-end. Privatisation salle pour vos événements à partir de 12 personnes.",
  phone: "01 30 50 46 14",
  email: "globodancing78@gmail.com",
  // Adresse de visite (lieu du restaurant)
  address: "Avenue Johanne Kepler",
  postcode: "78190",
  city: "Trappes",
  region: "Yvelines",
  country: "France",
  fullAddress: "Avenue Johanne Kepler, 78190 Trappes",
  // Approx. coordinates centre Trappes (78190)
  geo: { lat: 48.7775, lng: 1.9919 },
  // Google Maps (place + directions)
  googleMapsUrl: "https://www.google.com/maps/search/?api=1&query=Globo+Dancing+Avenue+Johanne+Kepler+Trappes",
  mapEmbedUrl: "https://www.google.com/maps?q=Avenue+Johanne+Kepler+78190+Trappes&output=embed",
  mapDirectionsUrl: "https://www.google.com/maps/dir/?api=1&destination=Avenue+Johanne+Kepler+78190+Trappes",
  hours: [
    { d: "Mardi — Jeudi", h: "12h–14h30 · 19h–22h30" },
    { d: "Vendredi — Samedi", h: "12h–14h30 · 19h–01h" },
    { d: "Dimanche", h: "12h–16h" },
    { d: "Lundi", h: "Fermé" },
  ],
  // For schema.org openingHours
  openingHoursSpec: [
    { days: ["Tuesday","Wednesday","Thursday"], opens: "12:00", closes: "14:30" },
    { days: ["Tuesday","Wednesday","Thursday"], opens: "19:00", closes: "22:30" },
    { days: ["Friday","Saturday"], opens: "12:00", closes: "14:30" },
    { days: ["Friday","Saturday"], opens: "19:00", closes: "01:00" },
    { days: ["Sunday"], opens: "12:00", closes: "16:00" },
  ],
  privatization: {
    minGuests: 12,
    description: "Salle du fond privatisable pour vos anniversaires, baptêmes, mariages et événements d'entreprise — à partir de 12 personnes.",
  },
  // Google reviews (à actualiser quand vous me donnez la vraie note + place_id)
  google: {
    rating: 4.4,
    reviewCount: 124,
    // Lien de recherche Google qui ouvre la fiche établissement de Trappes
    profileUrl: "https://www.google.com/search?q=GLOBO+DANCING+Trappes+avis",
    // Place ID Google Maps (à remplir pour activer le lien direct "Laisser un avis")
    placeId: "",
    // Lien direct pour écrire un avis (généré automatiquement si placeId fourni)
    writeReviewUrl: "https://www.google.com/search?q=GLOBO+DANCING+Trappes+avis#lrd",
  },
  // Données légales (source: societe.com — SIREN 100171859)
  legal: {
    siren: "100 171 859",
    siret: "100 171 859 00018",
    vat: "FR83100171859",
    apeCode: "5610A",
    apeLabel: "Restauration traditionnelle",
    legalForm: "Société à responsabilité limitée (SARL)",
    legalAddress: "46 Avenue Roger Hennequin, 78190 Trappes",
    creationDate: "26 janvier 2026",
    director: "Sergio Goncalves",
    directorTitle: "Gérant",
    rcsCity: "Versailles",
    collectiveAgreement: "Hôtels Cafés Restaurants (IDCC 1979)",
  },
  social: {
    instagram: "https://www.instagram.com/globodancing/",
    facebook: "",
  },
};
